import { render, staticRenderFns } from "./Messagenav.vue?vue&type=template&id=52864440&"
import script from "./Messagenav.vue?vue&type=script&lang=js&"
export * from "./Messagenav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports